'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _utils = require('../utils');

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Doshas = function () {
  function Doshas(el) {
    var _this = this;

    (0, _classCallCheck3.default)(this, Doshas);

    this.els = {
      el: el,
      doshas: (0, _functional.getElements)('.js-Doshas-dosha', { context: el })
    };

    this.isTicking = false;
    this.lastKnownY = this.getScrollY();

    this.doshas = this.els.doshas.map(function (el) {
      var title = el.dataset.moduleTitle;

      var key = title.toLowerCase();
      var fixedAreaEl = (0, _functional.getElement)('.js-Dosha-fixedArea', { context: el });
      var startPoint = (0, _utils.getOffsetTop)(fixedAreaEl);
      var endPoint = startPoint + fixedAreaEl.offsetHeight;
      var mobileBar = (0, _functional.getElement)('.dsh-MobileBar-' + key);

      var _isActive = _this.lastKnownY >= startPoint;

      return {
        el: el,
        mobileBar: mobileBar,
        title: title,
        key: key,
        startPoint: startPoint,
        endPoint: endPoint,
        _isActive: _isActive,
        get isActive() {
          return this._isActive;
        },

        set isActive(val) {
          this._isActive = val;

          this.mobileBar.classList.toggle('dsh-MobileBar-visible', val);
        }
      };
    });

    this.onScroll = this.onScroll.bind(this);
    this.updateEl = this.updateEl.bind(this);

    this.isActive = null;

    var resizeFnc = function resizeFnc() {
      if (_this.isActive == null && window.innerWidth < _utils.mediaBreakpoints.md) {
        return _this.setup();
      } else {
        _this.isActive = false;
      }

      var isActiveAndShouldntBe = window.innerWidth >= _utils.mediaBreakpoints.md && _this.isActive;
      var isInactiveAndShouldBe = _this.isActive === false && window.innerWidth < _utils.mediaBreakpoints.md;

      if (isActiveAndShouldntBe) {
        _this.destroy();
      } else if (isInactiveAndShouldBe) {
        _this.setup();
      }
    };
    window.addEventListener('resize', (0, _utils.debounce)(resizeFnc, 50));
    resizeFnc();
  }

  (0, _createClass3.default)(Doshas, [{
    key: 'attachListeners',
    value: function attachListeners() {
      window.addEventListener('scroll', this.onScroll);
    }
  }, {
    key: 'detachListeners',
    value: function detachListeners() {
      window.removeEventListener('scroll', this.onScroll);
    }
  }, {
    key: 'setup',
    value: function setup() {
      this.attachListeners();

      this.isActive = true;
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.doshas.forEach(function (dosha) {
        dosha.isActive = false;
      });

      this.detachListeners();

      this.isActive = false;
    }
  }, {
    key: 'onScroll',
    value: function onScroll() {
      this.lastKnownY = this.getScrollY();

      this.requestTick();
    }
  }, {
    key: 'requestTick',
    value: function requestTick() {
      if (!this.isTicking) requestAnimationFrame(this.updateEl);

      // If a rAF is already queued we don't want to call another one
      this.isTicking = true;
    }
  }, {
    key: 'updateEl',
    value: function updateEl() {
      // Reset the tick so we can capture the next onScroll
      this.isTicking = false;

      // Do fun stuffs here
      this.setDoshaActiveStates();
    }
  }, {
    key: 'getScrollY',
    value: function getScrollY() {
      return window.scrollY || window.pageYOffset;
    }
  }, {
    key: 'setDoshaActiveStates',
    value: function setDoshaActiveStates() {
      var _this2 = this;

      this.doshas.forEach(function (dosha) {
        dosha.isActive = (0, _functional.isBetween)({
          number: _this2.lastKnownY,
          startNumber: dosha.startPoint,
          endNumber: dosha.endPoint
        });
      });
    }
  }]);
  return Doshas;
}();

exports.default = Doshas;